/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NewsletterLocationName,
    NewsletterLocationNameFromJSON,
    NewsletterLocationNameFromJSONTyped,
    NewsletterLocationNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface NewsletterSchemaOutName
 */
export interface NewsletterSchemaOutName {
    /**
     * 
     * @type {string}
     * @memberof NewsletterSchemaOutName
     */
    name: string;
    /**
     * 
     * @type {Array<NewsletterLocationName>}
     * @memberof NewsletterSchemaOutName
     */
    locations: Array<NewsletterLocationName>;
}

export function NewsletterSchemaOutNameFromJSON(json: any): NewsletterSchemaOutName {
    return NewsletterSchemaOutNameFromJSONTyped(json, false);
}

export function NewsletterSchemaOutNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsletterSchemaOutName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'locations': ((json['locations'] as Array<any>).map(NewsletterLocationNameFromJSON)),
    };
}

export function NewsletterSchemaOutNameToJSON(value?: NewsletterSchemaOutName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'locations': ((value.locations as Array<any>).map(NewsletterLocationNameToJSON)),
    };
}


